import React from "react";
import { GenreTagAutoComplete } from "App/Molecules/AutoCompletes/Genre";
import { FilterItem, inputCustomStyle } from "../../formStyle";
import { useAuthGrantStore } from "App/Routes/AuthGrant/Store";
import { IdActions } from "App/Routes/AuthGrant/Store/IdList";
import { Info } from "App/Atomics/AutoComplete/TagAutoComplete";

export const GenreIncludeFilter = () => {
  const [{ mode, searchList }, dispatch] = useAuthGrantStore(store => ({
    mode: store.IdList.mode,
    searchList: store.IdList.searchList
  }));
  const includeGenreList = searchList.Track.includeGenreList;
  const onSetGenreList = (info: Info[]) => {
    dispatch(IdActions.setIncludeGenreList({ idType: mode, genreList: info }));
  };
  return (
    <FilterItem>
      <div className="item-label">
        <span>장르 포함 리스트</span>
      </div>
      <div className="item-option-wrapper">
        <GenreTagAutoComplete
          style={inputCustomStyle}
          defaultValue={includeGenreList}
          onBlur={info => info && onSetGenreList(info as Info[])}
        />
      </div>
    </FilterItem>
  );
};
